
import {React, useContext, useState, useEffect } from "react";
import { Outlet } from "react-router";
//import Sidebar from "../../components/Sidebar";
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { useQuery, useMutation, gql } from '@apollo/client';
import UserContext from '../../../../../context/UserContext';
import ThemeContext from "../../../../../context/ThemeContext";
import { Link, useNavigate } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button"; 
import { Paginator } from 'primereact/paginator';
import "../../../../../index.css"

import AgencyCreateCoop from './AgencyCreateCoop'
import { Dialog } from 'primereact/dialog';
import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import HtlHotelRoomTypeCreate from "./HtlHotelRoomTypeCreate";

import HtlProdStockCardEditDialog from "./HtlProdStockCardEditDialog";

import HtlProdAccomCardEdit from "./HtlProdAccomCardEdit";

import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';
        




//theme
import "primereact/resources/themes/tailwind-light/theme.css";     
    
//core
import "primereact/resources/primereact.min.css";                                       
        


const GET_POST = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $prodType: String
    
  ) {
    tbl_product(order_by: { prod_code: asc },
      where: {
        firm_main_code: { _eq: $ownFirmMainCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
        prod_type: { _eq: $prodType }
       
      }
    ) {
     
        firm_main_code
        firm_sub_code
        prod_main_grp
        prod_sub_grp
        prod_code
        prod_name   
        prod_type    
        active
    }
  }
`;

const INSERT_RTYPE = gql`
  mutation InsertRoomType(
    $firmMainCode: String!
    $firmSubCode: String!
    $prodCode: String!
    $rClassCode: String!
    $rTypeCode: String!
    $rTypeName: String!
    $rBedType: String!    
    $active: Boolean
    $prodLevel: String
   
  ) {
    insert_tbl_product(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        prod_code: $prodCode,
        prod_main_grp: $rClassCode,
        prod_sub_grp: $rTypeCode,
        prod_name: $rTypeName,
        default_unit: $rBedType,
        active: true,
        prod_level: SUB,
        prod_type: "ACC",
        
      }
    ) {
      affected_rows
    }
  }
`;








const HtlProdAccomCardList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { users } = useContext(UserContext);
  const {varCode, setVarCode} = useContext(ThemeContext);
  
  const ownFirmMainCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  const prodType = "ACC";
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: {
      ownFirmMainCode,
      ownFirmSubCode,
      ownFirmSubType,
      prodType,
    },
  });

  const navigate = useNavigate();

  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';

  const close_form = messages[currentLocale].close_form;
  const create_room_classrec = messages[currentLocale].create_room_classrec;
  const search_by_name = messages[currentLocale].search_by_name;
  const main_code = messages[currentLocale].main_code;
  const sub_code = messages[currentLocale].sub_code;
  const room_class_code = messages[currentLocale].room_class_code;
  const room_class_name = messages[currentLocale].room_class_name;
  const int_id = messages[currentLocale].int_id;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;
  const create = messages[currentLocale].create;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const managing_room_type = messages[currentLocale].managing_room_type;
  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard;
  const room_class_tab = messages[currentLocale].room_class_tab;

  const items = [{ label: dashboard ,url: "/", target: '_self'}, { label: administrator ,url:"/htl/hotel-adm/main/" }, { label: managing_room_type  }];


 
  const [InsertRoomType] = useMutation(INSERT_RTYPE);


  const handleinsert = () => {
    InsertRoomType({
      variables: {
        firmSubCode: ownFirmSubCode,
        firmMainCode: ownFirmMainCode ,
        rClassCode: "ACC",
        rTypeCode: "ACC",
        rTypeName: "Accomadation",
        rBedType: "NIGHT",
        prodCode: "ACC",       
        active: true,
        
       
        
    
           
      },
    })
      .then(() => {
        window.alert("Accomodation insert successfully!");
        refetch();
        

      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };
  



  
 
  
  const [displayBasic, setDisplayBasic] = useState(false);
 
  console.log(users.firmcode);

  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0); // first1'i tanımlayın ve başlangıç değeri ayarlayın

const onRowsPerPageChange = (e) => {
  setRows1(e.value); // Görünen kayıt sayısını değiştir
  setFirst1(0); // İlk sayfadan başla
};

const onPageChange = (e) => {
  setFirst1(e.first);
  setRows1(e.rows1);
}

const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />; // paginatorLeft'i tanımlayın
const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />; // paginatorRight'ı tanımlayın

  
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const filteredFirms = data.tbl_product.filter((firm) =>
    firm.prod_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const actionTemplate = (rowData) => {
    refetch();
    return (
      <Link to={`/htl/hotel-adm/products/prodacmcard-edit/${rowData.prod_code}`}>
       
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
      </Link>
      
    );
      };
      
       
      const onClick = () => {
        setVarCode("");
        setDisplayBasic(true);       
        refetch();
      };

    
      
      const createLink = (rowData) => {
        return `/htl/hotel-adm/products/prodstccard-edit/${rowData}`;
      };


      const onClick2 = () => {
        
        setDisplayBasic(true);
        refetch();
      };
      
      const onHide = () => {
        setDisplayBasic(false);
        refetch();
        
      };



  const userAndCreatedAtTemplate = (rowData) => {
    return (
      <div>
        <div className="text-xs">{rowData.create_user}</div>
        <div className="text-xs">{rowData.created_at}</div>
      </div>
    );
  };

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-xs"
      : "text-gray-500 font-bold text-xs";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  return (

    

    
    
    
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
    <div className="flex justify-between items-center">
      <nav>
        <ul className="flex border-solid mt-3 rounded-md border-b outline-1 mb-5">
          {items.map((item, index) => (
            <li key={index} className={`flex items-center m-1 ${index === items.length - 1 ? 'font-normal' : ''}`}>
              {index !== 0 && <span className={`mx-3 ${index === items.length - 1 ? '' : 'font-light'}`}> &gt; </span>}
              {item.url ? (
                <Link to={item.url}>{item.label}</Link>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <button onClick={() => navigate(-1)} className="flex text-violet-900 hover:text-violet-200 font-bold">
        {close_form}
      </button>
    </div>
    
  

<div>
  
<Dialog visible={displayBasic} style={{ width: '80vw' }} onHide={onHide} header={"Product Card"}>
  <div className={`modal-backdrop bg-slate-600  ${displayBasic ? 'block' : 'hidden'}`}></div>
  <div>
    <p>
    <HtlProdStockCardEditDialog/>
    </p>
  </div>
</Dialog>
</div>
          
<div className="card flex ">      
<div className="container p-2 mx-auto ">
      <div className=" w-1/1 text-gray-950 flex gap-4">
        <input
          type="text"
          className="px-2 py-1 border rounded-md"
          placeholder={search_by_name}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      

      <div className="mt-0 flex  w-full justify-end ">
      <Button
  label={create_room_classrec}
  aria-label="Create"
  className="p-button-sm p-button-outlined bg-purple-800 hover:bg-purple-950 text-white font-semibold rounded-md"
  onClick={handleinsert}  
  // onClick={() => navigate("/htl/hotel-adm/products/prodstccard-edit/123")}
/>
        </div>
        </div></div></div>
      <div>
      <div className="card p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
        <DataTable
        scrollable scrollHeight="450px" loading={loading}
        value={filteredFirms}
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={currentPageReportTemplate}
        rows={rows1} // Bu satırı verilerinize uygun şekilde ayarlayın
        rowsPerPageOptions={[10, 20, 50]}
        first={first1} // Bu satırı verilerinize uygun şekilde ayarlayın
        onPage={(e) => setFirst1(e.first)} 
        onRowsPerPageChange={(e) => setRows1(e.value)}
      //  paginatorLeft={paginatorLeft}
      //  paginatorRight={paginatorRight}
        tableStyle={{ minWidth: '50rem',  maxHeight: '40rem' }}
        onPageChange={onPageChange}
        
       
        
        >
          <Column className="font-bold text-xs" field="firm_main_code" style={{ textAlign: 'left', width: '10rem' }} header={main_code}></Column>
          <Column className="text-xs" field="firm_sub_code" style={{ textAlign: 'left', width: '10rem' }} header={<span sortable className="font-bold text-gray-900">{sub_code}</span>}></Column>
          <Column className="text-xs" field="prod_main_grp" style={{ textAlign: 'left', width: '10rem' }} header={<span className="font-bold text-gray-900">{room_class_code}</span>}></Column>
          <Column className="text-xs" field="prod_sub_grp" style={{ textAlign: 'left', width: '10rem' }} header={<span className="font-bold text-gray-900">{room_class_code}</span>}></Column>
          
          
          <Column field="prod_code"
           className="text-xs text-right" 
           header={<span className="font-bold sortable text-gray-900">{room_class_name}</span>}
           style={{ textAlign: 'left', width: '10rem' }}
          >
          </Column>
          <Column field="prod_name" 
          className="text-sm" 
          header={<span className="font-bold text-gray-900">{room_class_name}</span>}>
          </Column>
          
          <Column
            body={userAndCreatedAtTemplate}
            header={<span className="font-bold text-xs text-gray-900">{create}</span>}
            style={{ textAlign: 'right', width: '6rem' }}
          />
           <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{statusrec}</span>}
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs" 
          />
         <Column
            body={actionTemplate}
            header={<span className="font-bold text-gray-900">{detail}</span>}
            
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-xs" 
          />
    
        </DataTable>
        
      </div>
    </div>
    </div>
 
  );
};

export default HtlProdAccomCardList;


/*

const GET_POST = gql`
  query MyQuery {
    tbl_firm_main {
      firm_code
      firm_name
      firm_type
      place
      active
      create_user
    }
  }
`;

const FirmList = () => {
  const { loading, error, data } = useQuery(GET_POST);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
      <h2 className="mb-4 text-2xl font-semibold leading-tight">Invoices</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col className="w-24" />
          </colgroup>
          <thead className="dark:bg-gray-700">
            <tr className="text-left">
              <th className="p-3">Firm Code #</th>
              <th className="p-3">Firm Name</th>
              <th className="p-3">Firm Type</th>
              <th className="p-3">Place</th>
              <th className="p-3 text-right">Create User</th>
              <th className="p-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {data.tbl_firm_main.map((firm) => (
              <tr
                key={firm.firm_code}
                className="border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900"
              >
                <td className="p-3">
                  <p>{firm.firm_code}</p>
                </td>
                <td className="p-3">
                  <p>{firm.firm_name}</p>
                </td>
                <td className="p-3">
                  <p>{firm.firm_type}</p>
                </td>
                <td className="p-3">
                  <p>{firm.place}</p>
                </td>
                <td className="p-3 text-right">
                  <p>{firm.create_user}</p>
                </td>
                <td className="p-3 text-right">
                  <span className="px-3 py-1 font-semibold rounded-md dark:bg-violet-400 dark:text-gray-900">
                    <span>{firm.active ? "Active" : "Inactive"}</span>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex-1 bg-gray-100">Ana içerik alanı </div>
    </div> 
  );
}; 

export default FirmList; */


